var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoleTrader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 7.5,
    fill: "#EAF8ED"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 7.5,
    stroke: "#EAF8ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9442 14.4166C12.9442 14.3389 12.977 14.2643 13.0353 14.2093C13.0937 14.1544 13.1728 14.1235 13.2553 14.1235H15.7443C15.8268 14.1235 15.906 14.1544 15.9643 14.2093C16.0227 14.2643 16.0554 14.3389 16.0554 14.4166C16.0554 14.4943 16.0227 14.5689 15.9643 14.6238C15.906 14.6788 15.8268 14.7097 15.7443 14.7097H13.2553C13.1728 14.7097 13.0937 14.6788 13.0353 14.6238C12.977 14.5689 12.9442 14.4943 12.9442 14.4166ZM22.2779 11.4857V20.8645C22.2779 21.0977 22.1796 21.3214 22.0046 21.4863C21.8295 21.6512 21.5921 21.7438 21.3446 21.7438H7.65505C7.40751 21.7438 7.1701 21.6512 6.99506 21.4863C6.82002 21.3214 6.72168 21.0977 6.72168 20.8645V11.4857C6.72168 11.2525 6.82002 11.0289 6.99506 10.864C7.1701 10.6991 7.40751 10.6064 7.65505 10.6064H11.0774V9.72716C11.0774 9.3385 11.2413 8.96576 11.5331 8.69094C11.8248 8.41611 12.2205 8.26172 12.6331 8.26172H16.3666C16.7791 8.26172 17.1748 8.41611 17.4665 8.69094C17.7583 8.96576 17.9222 9.3385 17.9222 9.72716V10.6064H21.3446C21.5921 10.6064 21.8295 10.6991 22.0046 10.864C22.1796 11.0289 22.2779 11.2525 22.2779 11.4857ZM11.6997 10.6064H17.2999V9.72716C17.2999 9.49397 17.2016 9.27032 17.0266 9.10543C16.8515 8.94053 16.6141 8.8479 16.3666 8.8479H12.6331C12.3855 8.8479 12.1481 8.94053 11.9731 9.10543C11.798 9.27032 11.6997 9.49397 11.6997 9.72716V10.6064ZM7.34393 11.4857V14.7097C9.52987 15.8638 11.994 16.4693 14.4998 16.4682C17.0056 16.4693 19.4697 15.8638 21.6557 14.7097V11.4857C21.6557 11.408 21.6229 11.3334 21.5646 11.2784C21.5062 11.2235 21.4271 11.1926 21.3446 11.1926H7.65505C7.57254 11.1926 7.4934 11.2235 7.43506 11.2784C7.37671 11.3334 7.34393 11.408 7.34393 11.4857ZM21.6557 20.8645V15.3764C19.452 16.4788 16.9949 17.055 14.4998 17.0544C12.0047 17.0551 9.54752 16.479 7.34393 15.3764V20.8645C7.34393 20.9423 7.37671 21.0168 7.43506 21.0718C7.4934 21.1267 7.57254 21.1576 7.65505 21.1576H21.3446C21.4271 21.1576 21.5062 21.1267 21.5646 21.0718C21.6229 21.0168 21.6557 20.9423 21.6557 20.8645Z",
    fill: "#2EBB49",
    stroke: "#2EBB49",
    strokeWidth: 0.4375
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoleTrader);
export default __webpack_public_path__ + "static/media/sole-trader.863bc5b9ec3fa96b0a79b56e1fcd083b.svg";
export { ForwardRef as ReactComponent };